import Swiper from "swiper";

export default function linkBoxesSlider() {
    const wrappers = document.querySelectorAll('.mtt-link-boxes')

    if (!wrappers.length) {
        return
    }

    wrappers.forEach(wrapper => {
        const slider = wrapper.querySelector('.swiper-container')

        if (!slider) {
            return
        }

        const prev = wrapper.querySelector('.swiper-button-prev')
        const next = wrapper.querySelector('.swiper-button-next')

        const SWIPER = new Swiper(slider, {
            slidesPerView: 1.1,
            speed: 800,
            spaceBetween: 24,
            freeMode: false,
            watchOverflow: true,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                401: {
                    spaceBetween: 24,
                    slidesPerView: 1.2
                },
                551: {
                    spaceBetween: 24,
                    slidesPerView: 1.5
                },
                701: {
                    spaceBetween: 24,
                    slidesPerView: 2
                },
                851: {
                    spaceBetween: 32,
                    slidesPerView: 2
                },
                1051: {
                    spaceBetween: 24,
                    slidesPerView: 3
                },
                1281: {
                    spaceBetween: 32,
                    slidesPerView: 3
                }
            }
        });
    })
}